import React from 'react';
import { Container } from 'reactstrap';

const NotFound = () => {
	return <Container className="m-5">
		<h1>
			404 Not Found
		</h1>
	</Container>;
};

export default NotFound;
